/// <reference path="controlador.js" />
/// <reference path="../scripts/knockout-3.1.0.js" />

var oFichaEmpresa;



function GetObjFichaEmpresa() {
    if (oFichaEmpresa == undefined) {
        oFichaEmpresa = new ObjFichaEmpresa();
    }
    return oFichaEmpresa;
}

function ObjFichaEmpresa() {
    var that = this;

    this.cargarFichaEmpresa = function (codEmpresa, stand) {
        var localobj = this;
        if (stand == undefined) stand = "";
        GetObjEventosPagInicial().setActivarOpcionMenu(GetObjConfiguracion().menuPrincipalActivo, 'D');
        url = "../wsListaExpositores.svc/GetFichaEmpresa?Feria=" + GetObjConfiguracion().feria + "&Codigo=" + codEmpresa + "&stand=" + stand;
        GetCargaArchivos().CargarFicheroJSON(GetObjFichaEmpresa().pintarFichaUI, url);
    }


    this.pintarFichaUI = function (data) {

        if (!data) {
            that.muestraError();
        }
        else {
            that.muestraFicha();

            GetObjControlador().saveAnalyticsOtros("Ficha Empresa", data.no);

            var idioma = GetObjConfiguracion().idio;
            FichaUI.verCita(false);
            FichaUI.idEmpresa(data.id);
            FichaUI.nombreEmpresa(data.no);
            FichaUI.direccion(data.di);
            FichaUI.cp(data.cp);
            FichaUI.poblacion(data.po);
            FichaUI.provincia(data.pr);
            FichaUI.telefono(data.tl);
            FichaUI.email(data.em);
            FichaUI.stand(data.st);
            FichaUI.tipoE(data.te);
            if (data.we) {
                if (data.we.indexOf("http") == -1)
                    FichaUI.web("http://" + data.we);
                else
                    FichaUI.web(data.we);
                FichaUI.verWeb(GetObjConfiguracion().verPIM === 'N');
            } else {
                FichaUI.web(data.we);
                FichaUI.verWeb(false);
            }
            if (data.video) {
                if (data.video.indexOf("http") == -1)
                    FichaUI.video("http://" + data.video);
                else
                    FichaUI.video(data.video);
            } else {
                FichaUI.video(data.video);
            }
            if (FichaUI.esEspanol()) {
                FichaUI.descripcion(data.dc);
                FichaUI.pais(data.pa);
                FichaUI.paisCatalogo(data.pc);

            }
            else {
                if (data.dci != "")
                    FichaUI.descripcion(data.dci);
                else
                    FichaUI.descripcion(data.dc);
                FichaUI.pais(data.pai);
                FichaUI.paisCatalogo(data.pci);
            }


            that.getTipoEmpresa(data.te);
            that.cargaLogoEmpresa(data.log, idioma);
            that.cargaListaUbicaciones(data.pb, data.st);
            that.cargaRedesSociales(data.soc, idioma);
            that.cargaListaSectores(data.lse, idioma);
            that.cargaListaFicherosEnlaces(data.lfe, idioma);
            that.cargaListaProductos(data.lpr, idioma);
            that.cargaListaActividades(data.lac, idioma);
            that.cargaListaMarcas(data.ltma, idioma);
            that.cargaListaDestacados(data.lpd, idioma);
            that.cargaListaGenericos(data.ltge, idioma);
            that.cargaListaRepresentadas(data.ltrs);
            that.cargaListaPaisesRepre(data.lprs, idioma);
            that.cargaListaCoexpos(data.lco);
            that.cargaListaCamposConf(data.lcc);
            that.cargarFavorito(data.id);
            that.componerLinkSVR(GetObjConfiguracion().feria, data.id, idioma);
            that.componerLinkNovedades(GetObjConfiguracion().feria, data.id, idioma);
            that.eventoImpresion();
            GetObjEventosPagInicial().cursorArriba();
        }

        that.pintarServicioReuniones(FichaUI);
    }

    this.eventoImpresion = function () {
        $(".impresionFichaEmpresa").unbind("click");
        $(".impresionFichaEmpresa").click(function (event) {
            event.preventDefault();
            GetObjControlador().imprimir(GetObjConstantes()._FICHA);
        });
    }

    this.pintarServicioReuniones = function (ficha) {
        if ((GetObjConfiguracion().opCita)) {
            var listEmpr = new Array();
            listEmpr.push({ id: ficha.idEmpresa(), activo: 'N' });
            url = "../wsListaExpositores.svc/GetEmpresasConAgenda";
            var data = {
                Feria: GetObjConfiguracion().feria,
                ListaEmpresasAComprobar: listEmpr
            }
            GetCargaArchivos().CargarFicheroJSONPost(that.pintarServicioReunionesUI, url, data, ficha);
        }
    }

    this.pintarServicioReunionesUI = function (datos, ficha) {
        if ((datos != undefined) && (datos != null) && (datos[0].activo == 'S') && (datos[0].id == ficha.idEmpresa()))
            ficha.verCita(true);
        else
            ficha.verCita(false);
    }


    this.getTipoEmpresa = function (tipoEmpr) {
        switch (tipoEmpr) {
            case "E":
                FichaUI.nombretipoEmpresa((FichaUI.language().tipoExpo).toUpperCase())
                FichaUI.representada(false);
                break;
            case "C":
                FichaUI.nombretipoEmpresa((FichaUI.language().tipoCoexpo).toUpperCase());
                FichaUI.representada(false);
                break;
            case "R":
                FichaUI.nombretipoEmpresa((FichaUI.language().tipoRepre).toUpperCase());
                FichaUI.representada(true);
                break;
            case "M":
                FichaUI.nombretipoEmpresa((FichaUI.language().tipoMarca).toUpperCase());
                FichaUI.representada(true);
                break;

        }
    }
    this.GetNombreImagenGrande = function (nombreImagen) {
        return nombreImagen.replace(nombreImagen.split("_")[0], "g150");
    },


        this.cargaLogoEmpresa = function (datosLogo, idioma) {

            var rutaImagen;
            if (datosLogo) {
                var logo = this.GetNombreImagenGrande(datosLogo.url);
                if (logo != null && logo != "") {
                    rutaImagen = GetObjConfiguracion().GetRutaFichero("I", logo);
                } else {
                    if (((GetObjConfiguracion().verImpresion) && (GetObjConfiguracion().verPIM === 'S')))
                        rutaImagen = "img/sinlogo150_oscuro.jpg";
                    else {
                        rutaImagen = GetObjConfiguracion().getRutaImagenPorDefecto(); // this.CargarImagenPorDefecto(idioma);
                    }
                }
            }
            else {
                if (((GetObjConfiguracion().verImpresion) && (GetObjConfiguracion().verPIM === 'S')))
                    rutaImagen = "img/sinlogo150_oscuro.jpg";
                else {
                    rutaImagen = GetObjConfiguracion().getRutaImagenPorDefecto(); // this.CargarImagenPorDefecto(idioma);
                }
            }
            FichaUI.logoEmpresa(rutaImagen);

            //var alto = $("#IdDivLogo").height();
            //if (alto > 100)
            //    $("#IdLogo").css("margin-top", ((alto/3)-10)+"px");

        }

    this.cargaListaUbicaciones = function (pabellon, stand) {
        var tPabellon = pabellon.split(";");
        var tStand = stand.split(";");
        var ubicacion;
        var nuevoarray = [];
        if (pabellon && stand) {
            for (i = 0; i < tStand.length; i++) {
                ubicacion = "";
                ubicacion = ubicacion.concat(FichaUI.language().pabellon + " ");
                ubicacion = ubicacion.concat(tPabellon[i] + " - ");
                if (i == (tStand.length - 1)) {
                    ubicacion = ubicacion.concat(tStand[i])
                } else {
                    ubicacion = ubicacion.concat(tStand[i] + ", ")
                };

                nuevoarray.push({ nombreUbicacion: ubicacion, stand: tStand[i] });
            }
            FichaUI.listaUbicaciones(nuevoarray);
            FichaUI.listaUbicaciones.sort(function (a, b) { return a.nombreUbicacion > b.nombreUbicacion; });
        }
        else
            FichaUI.listaUbicaciones([]);
    }

    this.cargaRedesSociales = function (listaRedes, idioma) {
        if (listaRedes != null) {
            var rutaImg, urlRed;
            var nuevoarray = $.map(listaRedes, function (red) {
                rutaImg = GetObjConfiguracion().GetRutaFichero("I", red.img);
                urlRed = red.url;
                if (urlRed.indexOf("http") == -1)
                    urlRed = "http://" + urlRed;
                return { nombreRed: red.nom, rutaImg: rutaImg, urlRed: urlRed };
            });
            FichaUI.listaRedes(nuevoarray);
            FichaUI.listaRedes.sort(function (a, b) { return a.nombreRed > b.nombreRed; });
        }
        else
            FichaUI.listaRedes([]);

    }

    this.cargaListaFicherosEnlaces = function (listaFicheros, idioma) {
        if (listaFicheros != null) {
            var ruta, url, nombre;
            var nuevoarray = $.map(listaFicheros, function (fichero) {

                if (idioma == "es")
                    nombre = fichero.v;
                else
                    nombre = fichero.vi;

                if (fichero.t == "P") //si es PDF
                {
                    url = fichero.url;
                    ruta = GetObjConfiguracion().GetRutaFichero("R", fichero.url);
                    return { nombreF: nombre, rutaF: ruta, tipo: fichero.t };
                }
                else {
                    url = fichero.url;
                    if (url.indexOf("http") == -1)
                        url = "http://" + url;
                    return { nombreF: nombre, rutaF: url, tipo: fichero.t };
                }

            });
            FichaUI.listaFicheros(nuevoarray);
            //FichaUI.listaFicheros.sort();
        }
        else
            FichaUI.listaFicheros([]);
    }

    this.cargaListaSectores = function (listaSect, idioma) {
        if (listaSect != null) {
            var nuevoarray = $.map(listaSect, function (sector) {
                if (idioma == "es")
                    return sector.v;
                else
                    return sector.vi;
            });
            FichaUI.listaSectores(nuevoarray);
            FichaUI.listaSectores.sort();
        }
        else
            FichaUI.listaSectores([]);
    }

    this.cargaListaProductos = function (listaProd, idioma) {
        if (listaProd != null) {
            var nuevoarray = $.map(listaProd, function (producto) {
                if (idioma == "es")
                    return producto.v;
                else
                    return producto.vi;
            });
            FichaUI.listaProductos(nuevoarray);
            FichaUI.listaProductos.sort();
        }
        else
            FichaUI.listaProductos([]);
    }

    this.cargaListaActividades = function (listaAct, idioma) {
        if (listaAct != null) {
            var nuevoarray = $.map(listaAct, function (actividad) {
                if (idioma == "es")
                    return actividad.v;
                else
                    return actividad.vi;
            });
            FichaUI.listaActividades(nuevoarray);
            FichaUI.listaActividades.sort();
        }
        else
            FichaUI.listaActividades([]);
    }

    this.cargaListaMarcas = function (listaMarcas, idioma) {
        if (listaMarcas != null) {
            var nuevoarray = $.map(listaMarcas, function (marca) {
                var objMarca = { id: marca.id, nombreMarca: marca.v, lpaises: [] };
                if (marca.lpa) {
                    for (i = 0; i < marca.lpa.length; i++) {
                        var pais;
                        if (idioma == "es")
                            pais = marca.lpa[i].v;
                        else
                            pais = marca.lpa[i].vi;
                        objMarca.lpaises.push(pais);
                    }
                }
                return objMarca;
            });
            FichaUI.listaMarcas(nuevoarray);
            FichaUI.listaMarcas.sort(function (a, b) { return a.nombreMarca > b.nombreMarca; });
        }
        else
            FichaUI.listaMarcas([]);
    }

    this.cargaListaDestacados = function (listaDest, idioma) {
        if (listaDest != null) {
            var rutaImagen;
            var nuevoarray = $.map(listaDest, function (prodDest) {
                var logo = prodDest.url;
                if (logo != null && logo != "") {
                    rutaImagen = GetObjConfiguracion().GetRutaFichero("I", logo);
                } else {
                    rutaImagen = "img/sinlogo150.jpg";
                }
                if (idioma == "es")
                    return { logoDestacado: rutaImagen, desCorta: prodDest.dc, desLarga: prodDest.dl, video: prodDest.video, visibleVideo: prodDest.video != null && prodDest.video !== "" };
                else
                    return { logoDestacado: rutaImagen, desCorta: prodDest.dci, desLarga: prodDest.dli, video: prodDest.video, visibleVideo: prodDest.video != null && prodDest.video !== "" };
            });
            FichaUI.listaDestacados(nuevoarray);
            FichaUI.listaDestacados.sort(function (a, b) { return a.desCorta > b.desCorta; });
        }
        else
            FichaUI.listaDestacados([]);
    }

    this.cargaListaGenericos = function (listaGenericos, idioma) {
        if (listaGenericos != null) {
            var objTipoGene;
            var nuevoarray = $.map(listaGenericos, function (tipoGenerico) {
                if (idioma == "es") {
                    objTipoGene = { nombreTipoGene: tipoGenerico.v, lgenericos: [], bDesplegarGene: true };
                    objTipoGene.bDesplegarGene = ko.observable(true);
                    if (tipoGenerico.lge) {
                        $.map(tipoGenerico.lge, function (generico) {
                            objTipoGene.lgenericos.push(generico.v);
                        });
                    }
                    return objTipoGene;
                }
                else {
                    objTipoGene = { nombreTipoGene: tipoGenerico.vi, lgenericos: [], bDesplegarGene: true };
                    objTipoGene.bDesplegarGene = ko.observable(true);
                    if (tipoGenerico.lge) {
                        $.map(tipoGenerico.lge, function (generico) {
                            objTipoGene.lgenericos.push(generico.vi);
                        });
                    }
                    return objTipoGene;
                }
            });
            FichaUI.listaGenericos(nuevoarray);
            FichaUI.listaGenericos.sort(function (a, b) { return a.nombreTipoGene > b.nombreTipoGene; });
        }
        else
            FichaUI.listaGenericos([]);
    }

    this.cargaListaRepresentadas = function (listaRepre, idioma) {
        /*        if (listaRepre != null)
                {
                    var nuevoarray = $.map(listaRepre, function (repre) {
                        return { id: repre.id, nombreRepre: repre.v };
                    });
                    FichaUI.listaRepresentadas(nuevoarray);
                }
                else
                    FichaUI.listaRepresentadas([]);*/


        if (listaRepre != null) {
            var nuevoarray = $.map(listaRepre, function (repre) {
                var objRepre = { id: repre.id, nombreRepresentada: repre.v, lpaises: [] };
                if (repre.lpa) {
                    for (i = 0; i < repre.lpa.length; i++) {
                        var pais;
                        if (idioma == "es")
                            pais = repre.lpa[i].v;
                        else
                            pais = repre.lpa[i].vi;
                        objRepre.lpaises.push(pais);
                    }
                }
                return objRepre;
            });
            FichaUI.listaRepresentadas(nuevoarray);
            FichaUI.listaRepresentadas.sort(function (a, b) { return a.nombreRepresentada > b.nombreRepresentada; });
        }
        else
            FichaUI.listaRepresentadas([]);

    }

    this.cargaListaPaisesRepre = function (listaPaises, idioma) {
        if (listaPaises != null) {
            var nuevoarray = $.map(listaPaises, function (pais) {
                if (idioma == "es")
                    return pais.v
                else
                    return pais.vi;
            });
            FichaUI.listaPaisesRepre(nuevoarray);
            FichaUI.listaPaisesRepre.sort();
        }
        else {
            FichaUI.listaPaisesRepre([]);
        }
    }

    this.cargaListaCoexpos = function (listaCoexpos) {
        if (listaCoexpos != null) {
            var nuevoarray = $.map(listaCoexpos, function (coexpo) {
                return { id: coexpo.id, nombreCoexpo: coexpo.v };
            });
            FichaUI.listaCoexpos(nuevoarray);
            FichaUI.listaCoexpos.sort(function (a, b) { return a.nombreCoexpo > b.nombreCoexpo; });
        }
        else
            FichaUI.listaCoexpos([]);
    }

    this.cargaListaCamposConf = function (listaCampos) {
        if (listaCampos != null) {
            var nuevoarray = $.map(listaCampos, function (campo) {
                if (FichaUI.esEspanol())
                    return { nombreCampo: campo.no, valor: campo.v, esTitulo: campo.tc }
                else
                    return { nombreCampo: campo.noi, valor: campo.v, esTitulo: campo.tc }
            });
            FichaUI.listaCampos(nuevoarray);
            //FichaUI.listaCampos.sort(function (a, b) { return a.nombreCampo > b.nombreCampo; });
        }
        else
            FichaUI.listaCampos([]);
    }

    this.mostrarProductoModal = function (ele) {
        if (ele != undefined) {
            var src = ko.dataFor(ele).logoDestacado;
            var res = src.replace("p_", "pg_");
            $('#imagepreview').attr('src', res);
            $("#myModalLabel").html(ko.dataFor(ele).desCorta);
            $('#imagemodal').modal('show');
        }
    }

    this.saveAnalyticsWeb = function (ele) {
        if (ele != undefined)
            GetObjControlador().saveAnalyticsOtros("WEB EMPRESA", ko.dataFor(ele).nombreEmpresa());
    }

    this.saveAnalyticsSR = function (ele) {
        if (ele != undefined)
            GetObjControlador().saveAnalyticsOtros("SERVICIO DE REUNIONES", ko.dataFor(ele).nombreEmpresa());
    }

    this.saveAnalyticsNovedades = function (ele) {
        if (ele != undefined)
            GetObjControlador().saveAnalyticsOtros("NOVEDADES", ko.dataFor(ele).nombreEmpresa());
    }

    this.favoriteado = function (ele) {
        if (ele != undefined) {
            var id = ko.dataFor(ele).idEmpresa();

            if ($(ele).attr("class") == "icon-star") {
                $(ele).removeClass("icon-star");
                $(ele).addClass("icon-star-fill");
                //GetFavoritos().AddFavorito(id, GetObjConfiguracion().feria, '');
                var tipoEmpresa = ko.dataFor(ele).tipoE();
                var stand = ko.dataFor(ele).stand();
                if (tipoEmpresa === "C")
                    GetFavoritos().AddFavorito(id, GetObjConfiguracion().feria, stand);
                else
                    GetFavoritos().AddFavorito(id, GetObjConfiguracion().feria, 'X');

            } else {
                $(ele).removeClass("icon-star-fill");
                $(ele).addClass("icon-star");
                GetFavoritos().DeleteFavorito(id, GetObjConfiguracion().feria);
            }
        }
    }

    this.cargarFavorito = function (id) {
        if (id != undefined) {
            if (GetFavoritos().BuscarFavorito(id, GetObjConfiguracion().feria)) {
                $("#favCompany").removeClass("icon-star");
                $("#favCompany").addClass("icon-star-fill");
            }
            else {
                $("#favCompany").removeClass("icon-star-fill");
                $("#favCompany").addClass("icon-star");
            }
        }
    }

    this.componerLinkSVR = function (feria, idEmpresa, idioma) {
        var idEmpresaSeparado = idEmpresa.split("_");
        var codCatalogo = ((idEmpresaSeparado[2] < 10) ? "0" : "") + idEmpresaSeparado[2];
        var codInsercion = idEmpresaSeparado[0] + codCatalogo;
        var codempsec = idEmpresaSeparado[1];
        FichaUI.linkSVR(GetObjControlador().urlSVR + "&codFeriaGC=" + feria + "&idioma=" + idioma + "&codInsercion=" + codInsercion + "&codempsec=" + codempsec);
    }

    this.componerLinkNovedades = function (feria, idEmpresa, idioma) {
        var idEmpresaSeparado = idEmpresa.split("_");
        var EmpresaPex = idEmpresaSeparado[0];
        FichaUI.linkNovedades(GetObjControlador().urlNovedades + "?MM=1&&ssVerFerias=*&ssPEX=" + EmpresaPex + "&ssCodigoEdicionCertamen=" + feria);
    }

    this.muestraError = function () {
        $("#contFicha").hide();
        $("#divNoFicha").css("display", "block");
    }
    this.muestraFicha = function () {
        $("#divNoFicha").hide();
        $("#contFicha").css("display", "block");

    }
}


ObjFichaEmpresa.prototype = {

}